import { create } from 'zustand';
import { CONSTANTS } from '../constants/constants';

export const useTabStore = create((set, get) => ({
  activeTab: CONSTANTS.TABS.HOME,
  
  setActiveTab: (tabName) => set({ activeTab: tabName }),
}));